import { useEffect, useMemo, useState } from 'react';
import { shiftReportsService } from '../../services/reports/shift-reports.service';
import type { ShiftEmployeeDetailedReport, ShiftEmployeeSummaryReport } from '../../models/reports.types';
import { type ReportMode } from './reports-page.types';
import { currentMonth } from './reports-page.utils';

export function useReportsPageController() {
  const [mode, setMode] = useState<ReportMode>('detailed');
  const [month, setMonth] = useState(currentMonth);
  const [minimumWorkedDays, setMinimumWorkedDays] = useState(0);
  const [detailed, setDetailed] = useState<ShiftEmployeeDetailedReport | null>(null);
  const [summary, setSummary] = useState<ShiftEmployeeSummaryReport | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);
    const request =
      mode === 'detailed'
        ? shiftReportsService.getDetailed(month).then((payload) => {
            if (active) setDetailed(payload);
          })
        : shiftReportsService.getSummary().then((payload) => {
            if (active) setSummary(payload);
          });

    request
      .catch(() => {
        if (active) setError('לא ניתן לטעון את הדוח כרגע.');
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [mode, month]);

  const filteredMonths = useMemo(
    () => summary?.months.filter((row) => row.workedDays >= minimumWorkedDays) ?? [],
    [summary, minimumWorkedDays],
  );

  return {
    mode,
    setMode,
    month,
    setMonth,
    minimumWorkedDays,
    setMinimumWorkedDays,
    detailed,
    summary,
    isLoading,
    error,
    filteredMonths,
  };
}
